// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tpujpzojoqwytuhgbwtw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRwdWpwem9qb3F3eXR1aGdid3R3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjcwMjc3ODIsImV4cCI6MjA4MjYwMzc4Mn0.FWoxjkrmUcPA918-nyew0OsO5xq_fP9HWHOYfNd2U0E";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
